import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../constants/styles';
let {
  HEADER_ADMIN_BG_COLOR,
  HEADER_FONT_COLOR,
  TABLE_BG_COLOR,
  HIGHLIGHT_COLOR
} = constants;

let styles = {
  sidebar: {
    height: '100%',
    width: 225,
    backgroundColor: HEADER_ADMIN_BG_COLOR,
    color: HEADER_FONT_COLOR,
    overflow: 'auto'
  },
  logo: {
    flexShrink: 0,
    marginLeft: 30,
    width: 130,
    margin: 35
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0
  },
  item: {
    display: 'flex',
    padding: 15,
    paddingLeft: 35,
    margin: '10px 0',
    fontWeight: 500,
    textDecoration: 'none',
    color: 'white',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: TABLE_BG_COLOR
    }
  },
  activeItem: {
    backgroundColor: HIGHLIGHT_COLOR,
    ':hover': {
      backgroundColor: HIGHLIGHT_COLOR
    }
  },
  itemIcon: {
    fontWeight: 'bold'
  },
  itemSvgIcon: {
    marginTop: 0,
    height: 12,
    width: 12
  },
  itemText: {
    marginLeft: 10
  },
  disabledItem: {
    color: 'grey',
    backgroundColor: HEADER_ADMIN_BG_COLOR,
    ':hover':{backgroundColor:HEADER_ADMIN_BG_COLOR}
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/adminsidebar/AdminSidebar.styles.js